import { useQuery } from "@apollo/client/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { adaptDelegacionesBOTArray } from "../../../adapters/delegacionesBOTAdapter";
import { GET_METODOS_CONFORMIDADES, adaptMetodosConformidadesArray } from "../../../data/graphQL/queries/Conformidades/getMetodosConformidades";
import { GET_DELEGACIONES_BOT } from "../../../data/graphQL/queries/ReporteBOT/getDelegacionesBOT";
import { usePersistFilters } from "../../../hooks/usePersistFilters";

export const useGetFilters = () => {
    const [delegaciones, setDelegaciones] = useState([]);
    const [metodos, setMetodos] = useState([]);

    const { filters, handleChangeFilters } = usePersistFilters({
        idDelegacion: 0,
        txtFiltro: '',
        idMetodo: -1,
        mes: parseInt(moment().format('MM')),
        anio: parseInt(moment().format('YYYY')),
    }, `ConformidadesFilters`);

    const { data: delegacionesData } = useQuery(GET_DELEGACIONES_BOT, {
        fetchPolicy: 'no-cache'
    });

    useEffect(() => {
        if (!delegacionesData) return;
        setDelegaciones(adaptDelegacionesBOTArray(delegacionesData.delegacionesBOT.valorEsperado)?.filter(x => x.displayName.toLowerCase() !== 'todos'));
        handleChangeFilters('idDelegacion', filters?.idDelegacion);
    }, [delegacionesData]);

    const { data: metodosData } = useQuery(GET_METODOS_CONFORMIDADES, {
        fetchPolicy: 'no-cache'
    });

    useEffect(() => {
        if (!metodosData) return;
        const todos = { id: -1, displayName: 'Todos' };
        setMetodos([todos, ...adaptMetodosConformidadesArray(metodosData.metodosEnvio)]);
    }, [metodosData]);

    return {
        filters,
        handleChangeFilters,
        delegaciones,
        metodos,
    };
};